<template>
    <v-layout
        row
        wrap
    >
        <!-- Product Received -->
        <v-flex>
            <!-- Button -->
            <v-btn
                class="my-0"
                color="success"
                block
                @click.stop="dialog = true"
            >
                <v-icon
                    left
                    size="20"
                >
                    {{ buttonIcon }}
                </v-icon>
                Product Received
            </v-btn>
            <!-- Dialog -->
            <v-dialog
                v-model="dialog"
                max-width="600"
            >
                <v-card>
                    <v-card-title>
                        <h3 class="headline">
                            Product Received
                        </h3>
                    </v-card-title>
                    <v-card-text>
                        <p>Confirm the product has been received. This will notify the customer service department.</p>
                        <v-form
                            ref="form"
                            @submit.prevent="onConfirm"
                        >
                            <v-textarea
                                label="Message"
                                v-model="form.message"
                                :rules="[rules.required]"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            flat
                            @click="dialog = false"
                            :disabled="isSubmitting"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            color="primary"
                            @click="onConfirm"
                            :disabled="isSubmitting"
                            :loading="isSubmitting"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios'
import { statuses, PRODUCT_RECEIVED } from '../../../utils/constants/statuses'
import { defaultError422, requestErrorMessage } from '../../../utils/constants/errors'
import SnackBus from '../../../utils/buses/snackBus'
import UserBus from '../../../utils/buses/userBus'

export default {
    props: {
        returnId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            buttonIcon: statuses[PRODUCT_RECEIVED].icon,
            dialog: false,
            form: {
                proNumber: null,
                message: null
            },
            rules: {
                required: value => !!value || 'This field is required'
            },
            isSubmitting: false
        }
    },
    methods: {
        onConfirm () {
            if (!this.$refs.form.validate()) {
                SnackBus.showMessage(defaultError422, 'error')
                return
            }
            this.isSubmitting = true
            const formData = new FormData()
            formData.set('token', UserBus.token)
            formData.set('comment', this.form.message)

            axios.post('/api/returns/' + this.returnId + '/freightgroup/receive', formData)
                .then(res => {
                    // refresh data and close dialog
                    this.$emit('refresh-data', true)
                    this.dialog = false
                    SnackBus.showMessage('Status changed to ' + statuses[PRODUCT_RECEIVED].text, 'success')

                    // freight group can not view product received tickets so they are navigated back to list page
                    if (!UserBus.userIs.prpAdmin()) {
                        this.$router.push({ name: 'returnsList' })
                    }
                })
                .catch(err => {
                    console.log('Freight Group Product Received Error', err)
                    SnackBus.showMessage(requestErrorMessage, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        }
    }
}
</script>

<style>

</style>
